View = require 'view'
attachmentThumbProcessingTemplate = require 'views/templates/attachment_thumb_processing'

module.exports = class InProgressAttachmentView extends View
  render: ->
    @$el.html(attachmentThumbProcessingTemplate())
    @



// WEBPACK FOOTER //
// ./app/scripts/views/attachment/in-progress-attachment.coffee